import React from 'react';
import { Mail, Phone, MapPin, Instagram, Facebook, Youtube } from 'lucide-react';
import { Button } from './ui/button';

const ContactSection = ({ onBookNow }) => {
  return (
    <section id="contact" className="perf-section py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Left: Contact Info */}
          <div className="space-y-8">
            <div className="space-y-4">
              <span className="text-sm uppercase tracking-widest text-gray-500 font-medium">Get In Touch</span>
              <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
                Let's Capture
                <br />
                Your Story
              </h2>
              <p className="text-lg text-gray-600">
                Ready to book your wedding photography? Get in touch with us today
                and let's start planning your perfect day.
              </p>
            </div>

            {/* Contact Details */}
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Email</div>
                  <a href="mailto:info.sagarsenphotography@gmail.com" className="text-gray-600 hover:text-gray-900 transition-colors break-all">
                    info.sagarsenphotography@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Phone</div>
                  <a href="tel:+919051353785" className="text-gray-600 hover:text-gray-900 transition-colors">
                    +91 9051353785
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Location</div>
                  <div className="text-gray-600">
                    West Bengal, India
                  </div>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="space-y-4">
              <div className="font-semibold text-gray-900">Follow Us</div>
              <div className="flex gap-4">
                <a
                  href="https://www.instagram.com/sagar_sen_photography/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-100 hover:bg-gray-900 rounded-lg flex items-center justify-center transition-colors duration-200 group"
                >
                  <Instagram className="w-5 h-5 text-gray-900 group-hover:text-white transition-colors" />
                </a>
                <a
                  href="https://www.facebook.com/fotokraftphotography/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-100 hover:bg-gray-900 rounded-lg flex items-center justify-center transition-colors duration-200 group"
                >
                  <Facebook className="w-5 h-5 text-gray-900 group-hover:text-white transition-colors" />
                </a>
                <a
                  href="https://www.youtube.com/@sagrsen"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-100 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors duration-200 group"
                >
                  <Youtube className="w-5 h-5 text-gray-900 group-hover:text-white transition-colors" />
                </a>
              </div>
            </div>
          </div>

          {/* Right: CTA */}
          <div className="bg-gray-50 p-12 rounded-2xl flex flex-col items-center justify-center text-center space-y-8">
            <div className="space-y-4">
              <h3 className="text-3xl font-bold text-gray-900">
                Ready to Book?
              </h3>
              <p className="text-gray-600 max-w-md">
                Limited availability for 2025. Book your wedding photography session today
                and secure your date.
              </p>
            </div>
            <Button
              onClick={onBookNow}
              size="lg"
              className="bg-gray-900 hover:bg-gray-800 text-white px-12 py-8 text-lg font-medium transition-colors duration-200"
            >
              Book Your Event Now
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
